module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.isWrap ? 'JustWrapper' : _vm.tag, _vm._b({
    tag: "component",
    staticClass: "parts-catalog-list-item-link",
    class: {
      'parts-catalog-list-item-link_cursor': _vm.isWrap
    }
  }, 'component', _vm.bindings, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c99749e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/list/item/components/Link.vue
// module id = f6f6048bbc8d46e58cdf
// module chunks = 89